const m = require('minthril');
const { component } = require('../../component');

const RendererSelect = component(() => {
  return {
    view: ({ attrs: { value, onchange, disabled, inheritedRenderer } }) => {
      const inheritedLabel = inheritedRenderer === 'jsdom-first' ? 'jsdom first' : 'Chromium';
      return m('label.renderer-select', [
        m('span', 'Renderer'),
        m('select', { value: value ?? '', onchange, disabled }, [
          inheritedRenderer && m('option', { value: '' }, `Use site setting (${inheritedLabel})`),
          m('option', { value: 'chromium' }, 'Chromium'),
          m('option', { value: 'jsdom-first' }, 'jsdom first (experimental)')
        ]),
        m('small', 'jsdom first tries the lightweight renderer and falls back to Chromium when it detects a problem. Changing this setting invalidates cached pages.')
      ]);
    }
  };
});

module.exports = { RendererSelect };
